import React, { useMemo } from "react";
import { useSchool } from "../../DataStore/SchoolContext";
import { useStudent } from "../../DataStore/FeesStudentContext";
import FilterBar from "../../components/Common/FilterBar"; // ✅ adjust path to where your FilterBar lives

const StudentMgtHead = () => {
  const { classOptions, residenceOptions, feesGroupOptions } = useSchool();
  const { dispatch, filter, searchText, classId, feesGroupId, residenceId } = useStudent();

  const classOpts = useMemo(
    () =>
      (Array.isArray(classOptions) ? classOptions : []).map((c) => ({
        value: String(c.value ?? ""),
        label: c.title ?? "",
      })),
    [classOptions]
  );

  const residenceOpts = useMemo(
    () =>
      (Array.isArray(residenceOptions) ? residenceOptions : []).map((r) => ({
        value: String(r.value ?? ""),
        label: r.title ?? "",
      })),
    [residenceOptions]
  );

  const groupOpts = useMemo(
    () =>
      (Array.isArray(feesGroupOptions) ? feesGroupOptions : []).map((g) => ({
        value: String(g.value ?? ""),
        label: g.title ?? "",
      })),
    [feesGroupOptions]
  );

  return (
    <FilterBar
      title="Students Listing"
      subtitle="Search and filter students."
      controls={[
        {
          type: "search",
          value: searchText || "",
          placeholder: "Find student...",
          width: 300,
          onChange: (e) => dispatch({ type: "searchText", payload: e.target.value }),
          onEnter: filter,
        },
        {
          type: "select",
          value: feesGroupId || "", // if you have current value in store, bind it here
          placeholder: "Fees group",
          width: 170,
          options: groupOpts,
          onChange: (e) => dispatch({ type: "feesGroupId", payload: String(e.target.value) }),
        },
        {
          type: "select",
          value: classId || "", // if you have current value in store, bind it here
          placeholder: "Class",
          width: 150,
          options: classOpts,
          onChange: (e) => dispatch({ type: "classId", payload: String(e.target.value) }),
        },
        {
          type: "select",
          value: residenceId || "", // if you have current value in store, bind it here
          placeholder: "Residence",
          width: 160,
          options: residenceOpts,
          onChange: (e) => dispatch({ type: "residenceId", payload: String(e.target.value) }),
        },
      ]}
      actions={[
        {
          label: "Apply",
          iconClass: "fa fa-filter",
          onClick: filter,
          variant: "primary",
        },
      ]}
    />
  );
};

export default StudentMgtHead;
